"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.review = void 0;
var utils_1 = require("../../utils");
var qs = require("qs");
exports.review = function (axios) {
    return {
        getReviews: function (getReviewsRequest) {
            return axios.get('/reviews', getReviewsRequest);
        },
        putReviewsBestReview: function (request) {
            return axios.put('/reviews/best-review', request.data);
        },
        getReviewsReports: function (request) {
            return axios.get('/reviews/reports', request);
        },
        putReviewsStatus: function (request) {
            return axios.put('/reviews/status', request.data);
        },
        getReviewsReviewNo: function (request) {
            var url = utils_1.paramPathchange('/reviews/{reviewNo}', request);
            return axios.get(url);
        },
        putReviewsReviewNo: function (request) {
            var url = utils_1.paramPathchange('/reviews/{reviewNo}', request);
            return axios.put(url, request.data);
        },
        getReviewsReviewNoHistories: function (request) {
            var url = utils_1.paramPathchange('/reviews/{reviewNo}/histories', request);
            return axios.get(url);
        },
        getReviewsReviewNoReports: function (request) {
            var url = utils_1.paramPathchange('/reviews/{reviewNo}/reports', request);
            return axios.get(url);
        },
        putReviewsReviewNoStatus: function (request) {
            var url = utils_1.paramPathchange('/reviews/{reviewNo}/status', request);
            return axios.put(url, request.data);
        },
        putReviewsReviewNoBestReview: function (request) {
            var url = utils_1.paramPathchange('/reviews/{reviewNo}/best-review', request);
            return axios.put(url, request.data);
        },
        getReviewsReviewNoReportsReportNo: function (request) {
            var url = utils_1.paramPathchange('/reviews/{reviewNo}/reports/{reportNo}', request);
            return axios.get(url);
        },
        getReviewsConfigurations: function (getReviewsRequestConfigurations) {
            return axios.get('/reviews/configurations', getReviewsRequestConfigurations);
        },
        putReviewsConfigurations: function (_a) {
            var data = _a.data;
            return axios.put('/reviews/configurations', data);
        },
        getReviewsMemberSummaries: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/reviews/member-summaries?" + query);
        },
        getReviewsConfigurationsExcludedProducts: function (request) {
            return axios.get('/reviews/configurations/excluded-products', request);
        },
        deleteReviewsConfigurationsExcludedProducts: function (request) {
            return axios.delete('/reviews/configurations/excluded-products', request);
        },
        postReviewsConfigurationsExcludedProductsExcelBulk: function (request) {
            return axios.post('/reviews/configurations/excluded-products/excel/bulk', request.data);
        },
        getReviewsConfigurationsExcludedProductsExcelFailHistories: function (request) {
            return axios.get('/reviews/configurations/excluded-products/excel/fail-histories', request);
        },
        getReviewsReviewNoComments: function (request) {
            return axios.get("/reviews/" + request.pathParams.reviewNo + "/comments?page=" + request.params.page + "&size=" + request.params.size);
        },
        postReviewsReviewNoComments: function (request) {
            var url = utils_1.paramPathchange('/reviews/{reviewNo}/comments', request);
            return axios.post(url, request.data);
        },
        putReviewsReviewNoCommentsReviewCommentNo: function (request) {
            var url = utils_1.paramPathchange('reviews/{reviewNo}/comments/{reviewCommentNo}', request);
            return axios.put(url, request.data);
        },
        deleteReviewsReviewNoCommentsReviewCommentNo: function (request) {
            var url = utils_1.paramPathchange('reviews/{reviewNo}/comments/{reviewCommentNo}', request);
            return axios.delete(url);
        },
        getReviewsConfigurationsExcludedProductsAvailable: function (request) {
            return axios.get('/reviews/configurations/excluded-products/available', request);
        },
        getReviewsConfigurationsExcludedProductsExcel: function (request) {
            return axios.get('/reviews/configurations/excluded-products/excel', request);
        },
        getReviewsConfigurationsWidgetPreview: function (request) {
            return axios.get("/reviews/configurations/widget-preview?mallNo=" + request.params.mallNo + "&widgetType=" + request.params.widgetType + "&widgetCount=" + request.params.widgetCount);
        },
        getReviewsConfigurationsWidgetPreviewReviewedProducts: function (request) {
            return axios.get("/reviews/configurations/widget-preview/reviewed-products?mallNo=" + request.params.mallNo + "&widgetCount=" + request.params.widgetCount);
        },
        putReviewsConfigurationsExcludedProductsSync: function (request) {
            return axios.put('/reviews/configurations/excluded-products/sync', request.data);
        }
    };
};
